var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('h1',[_vm._v(" "+_vm._s(_vm.heading)+" "),(_vm.subHeading)?_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.subHeading))]):_vm._e()]),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }